import React, { useState, useEffect } from 'react';

const GoToTop = () => {
    const [showGoToTop, setShowGoToTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowGoToTop(window.scrollY >= 200);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            {showGoToTop && (
                <button onClick={() => window.scrollTo(0, 0)} className="btn goToTop">
                    Go to top<i className="ri-arrow-up-circle-line"></i>
                </button>
            )}
        </>
    );
};

export default GoToTop;
